import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setShowTemplateSlideToFalse } from "../../../store/CatalogSlice";

const TemplateSlider = () => {
    const dispatch = useDispatch();
    const template = useSelector((state: any) => state.catalog.Template);
    const assembly = template?.assembly?.[0];

    // Helper to safely fetch nested names
    const getName = (obj?: any) => obj?.["atmos-data"]?.["name"] ?? "N/A";

    // Section configs
    const sections = [
        {
            title: "Bus",
            fields: [
                { label: "BUS OBC", value: getName(assembly?.core?.["Bus OBC"]) },
                { label: "BUS OS", value: getName(assembly?.core?.["Bus OS"]) },
                {
                    label: "ADCS",
                    value:
                        template?.["template-attribute"]?.["ADCS"] === "iADCS"
                            ? getName(assembly?.iADCS)
                            : "Discrete",
                },
                { label: "IMU", value: "Discrete" },
                { label: "GPS", value: getName(assembly?.core?.GPS) },
                assembly?.core?.Thruster && {
                    label: "Thruster",
                    value:
                        template?.["template-attribute"]?.["propulsion"] === "Yes"
                            ? getName(assembly?.core?.Thruster)
                            : "No",
                },
            ].filter(Boolean),
        },
        {
            title: "Payload Server",
            fields: [
                { label: "Payload OBC", value: getName(assembly?.payloadServer?.["Payload OBC"]) },
                { label: "Payload SSD", value: getName(assembly?.payloadServer?.["Payload SSD"]) },
            ],
        },
        {
            title: "Communication Devices",
            fields: [
                { label: "S-Band Radio", value: getName(assembly?.communication?.["comm-devices"]?.["S-band"]) },
                { label: "S-Band Antenna", value: getName(assembly?.communication?.antennas?.["S-band"]) },
                assembly?.communication?.["comm-devices"]?.["X-band"] && {
                    label: "X-Band Radio",
                    value: `${getName(assembly?.communication?.["comm-devices"]?.["X-band"])}${assembly?.communication?.["comm-devices"]?.["X-band"]?.user_data?.numUnits
                        ? ` (${assembly?.communication?.["comm-devices"]?.["X-band"]?.user_data?.numUnits})`
                        : ""
                        }`
                },
                assembly?.communication?.antennas?.["X-band"] && {
                    label: "X-Band Antenna",
                    value: getName(assembly?.communication?.antennas?.["X-band"]),
                },
                assembly?.communication?.["comm-devices"]?.["Ka-band"] && {
                    label: "Ka-Band Radio",
                    value: getName(assembly?.communication?.["comm-devices"]?.["Ka-band"]),
                },
                assembly?.communication?.antennas?.["Ka-band"] && {
                    label: "Ka-Band Antenna",
                    value: getName(assembly?.communication?.antennas?.["Ka-band"]),
                },
                assembly?.communication?.["comm-devices"]?.UHF && {
                    label: "UHF Radio",
                    value: getName(assembly?.communication?.["comm-devices"]?.UHF),
                },
                assembly?.communication?.antennas?.UHF && {
                    label: "UHF Antenna",
                    value: getName(assembly?.communication?.antennas?.UHF),
                },
                assembly?.communication?.["comm-devices"]?.AIS && {
                    label: "AIS Radio",
                    value: getName(assembly?.communication?.["comm-devices"]?.AIS),
                },
                assembly?.communication?.antennas?.AIS && {
                    label: "AIS Antenna",
                    value: getName(assembly?.communication?.antennas?.AIS),
                },
            ].filter(Boolean),
        },
        {
            title: "Power",
            fields: [
                { label: "EPS unit", value: getName(assembly?.power?.EPS) },
                { label: "Battery Pack", value: getName(assembly?.power?.["Battery Pack"]) },
                {
                    label: "Solar Panel unit",
                    value: `${getName(assembly?.power?.["Solar Panel"])} (${template?.["template-attribute"]?.NumSolarPanel ?? 0
                        })`,
                },
            ],
        },
    ];

    return (
        <div className="right-slider-box">
            <div className="slider-header">
                <h4 className="mb-0">{template?.name}</h4>
            </div>

            <div className="slider-content">
                {sections.map((section, idx) => (
                    <div className="common-card-box" key={idx}>
                        <div className="common-card-header">{section.title}</div>
                        <div className="common-card-content">
                            <div className="d-flex flex-column">
                                {section.fields.map((field) => (
                                    <div className="d-flex" key={field?.label}>
                                        <span className="temp-label">{field?.label} </span>: {field.value}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="slider-footer">
                <Button
                    variant="primary"
                    type="button"
                    className="btn btn-primary pt-1 pb-1 pe-7 ps-7 fs-14"
                    onClick={() => dispatch(setShowTemplateSlideToFalse())}
                >
                    Close
                </Button>
            </div>
        </div>
    );
};

export default TemplateSlider;
